const DeviceType = {
  ANDROID: {
    key: 1,
    val: "安卓"
  },
  IOS: {
    key: 2,
    val: "IOS"
  },
  OTHER: {
    key: 3,
    val: "其他"
  }
};

const ForceUpdateFlag = {
  YES: {
    key: 1,
    val: "是"
  },
  NO: {
    key: 2,
    val: "否"
  }
};

const DisabledStatus = {
  ENABLE: {
    key: 1,
    val: "启用"
  },
  DISABLED: {
    key: 2,
    val: "禁用"
  }
};

const WebStatus = {
  SUCCESS: "200",
  UNAUTHORIZED: "401"
};

/**
 * 获取字典值(不适用类似 WebStatus)
 * @author miaoguoxin
 * @date 2020/9/9
 */
function getDictName(type, enums) {
  for (let index in enums) {
    let val = enums[index];
    if (typeof val == "function") {
      continue;
    }
    if (val.key == type) {
      return val.val;
    }
  }
}
export default {
  DeviceType,
  ForceUpdateFlag,
  DisabledStatus,
  WebStatus,
  getDictName
};
